import { PreLobbyGame, PreLobbyGamesRequest } from '../../../models';
import { BaseApiService } from '../../base-api-service';
import { env } from '../../../environment';

class LobbyController extends BaseApiService {
  public async getPreLobbyGames(params: PreLobbyGamesRequest): Promise<Array<PreLobbyGame>> {
    const url = `${this.url}/api/lobby/preLobby`;
    return await this.http.get(url, { params });
  }
}

export const lobbyController = new LobbyController({ url: env.origin });
